"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconSocialLinkedin = function SvgIconSocialLinkedin(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "social linkedin icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Social Linkedin Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.593 42h7.466V17.953H6.593V42zm3.736-27.33A4.328 4.328 0 016 10.334 4.33 4.33 0 0110.329 6a4.332 4.332 0 014.323 4.335 4.33 4.33 0 01-4.323 4.334zM42 42h-7.458V30.307c0-2.79-.05-6.376-3.878-6.376-3.88 0-4.473 3.038-4.473 6.177V42h-7.45V17.953h7.149v3.29h.104c.995-1.892 3.43-3.885 7.059-3.885 7.553 0 8.947 4.979 8.947 11.453V42z"
  }));
};

var _default = SvgIconSocialLinkedin;
exports.default = _default;